import React from "react";
import Button from "../../../../shared/components/Button";
import TqPanelExcessReduction from "./TqPanelExcessReduction";
import { getQuoteExcessLabel } from "../../utils/quoteDisplayData";

const TqPanelTable = ({
  quoteRows,
  configs,
  getSchemeImage,
  handleBuyClick,
  onOpen,
  splitForSpace,
  excessReductions,
}) => {
  const excessReductionColSpan = 5 + configs.length;
  const tableClass =
    "tw-mt-[1%] tw-w-full tw-border-collapse tw-text-dis-small tw-text-dis-text-2 [&_th]:tw-w-0 [&_th]:tw-border-x [&_th]:tw-border-solid [&_th]:tw-border-[#eeeeee] [&_th]:tw-border-t-0 [&_th]:tw-border-b-0 [&_th:first-child]:tw-border-l-0 [&_th:last-child]:tw-border-r-0 [&_td]:tw-border [&_td]:tw-border-solid [&_td]:tw-border-[#eeeeee] [&_td]:tw-border-b-0 [&_td:first-child]:tw-border-l-0 [&_td:last-child]:tw-border-r-0 [&_th]:tw-px-[10px] [&_th]:tw-py-[15px] [&_td]:tw-px-[10px] [&_td]:tw-py-[15px] [&_th]:tw-text-center [&_td]:tw-text-center [&_th]:tw-min-w-[100px] [&_td]:tw-min-w-[100px] max-[1650px]:[&_th]:tw-min-w-[10px] max-[1650px]:[&_td]:tw-min-w-[10px]";
  const paymentCellClass =
    "tw-max-w-[206px] [text-align:-webkit-center] !tw-px-5 !tw-py-[18px] max-[1498px]:!tw-px-[10px] max-[1498px]:!tw-py-[9px]";
  const detailRowClass =
    "tw-mb-1 tw-flex tw-justify-between tw-gap-[10px] tw-text-left tw-max-w-[206px]";
  const tableRowClass =
    "tw-border tw-border-solid tw-border-dis-deep-blue [&_td]:tw-border-t-[1.25px] [&_td]:tw-border-t-dis-deep-blue";

  return (
    <table className={tableClass}>
      <thead>
        <tr>
          <th>Provider</th>
          <th>
            Annual
            <br />
            Price
          </th>
          <th>
            Monthly Installments
          </th>
          <th>
            Policy Excesses
          </th>
          {configs.map((config) => {
            return (
              <th
                key={config.code}
              >
                {config.label}
              </th>
            );
          })}
          <th></th>
        </tr>
      </thead>
      <tbody>
        {quoteRows.map((row) => {
          const {
            quote,
            index,
            excessReduction,
            paymentInFullOption,
            financeOption,
            financeCharge,
            tableExcesses,
            configRows,
          } = row;
          return (
            <React.Fragment key={`row-${index}`}>
              <tr key={index} className={excessReduction ? tableRowClass : ""}>
                <td>{getSchemeImage(quote.schemeTableId)}</td>
                <td className={paymentCellClass}>
                  {paymentInFullOption && (
                    <div className="tw-mb-1">
                      <span
                        className="tw-block tw-text-center tw-text-lg tw-font-bold"
                      >
                        £
                        {paymentInFullOption.totalAmountToPayByCustomer.toLocaleString("en-GB", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  )}
                </td>
                <td className={paymentCellClass}>
                  {financeOption && (
                    <>
                          <div className="tw-mb-[10px] [&_div]:tw-border-x-0 [&_div]:tw-border-t-0 [&_div]:tw-border-b [&_div]:tw-border-solid [&_div]:tw-border-dis-divider [&_div]:tw-pb-1">
                            <div className={detailRowClass}>
                              <span>Deposit </span>
                              <span>£{financeOption.deposit}</span>
                            </div>
                            <div className={detailRowClass}>
                              <span>Monthly 9x </span>
                              <span>£{financeOption.installmentAmount}</span>
                            </div>
                            <div className={detailRowClass}>
                              <span className="tw-text-center tw-font-bold">Total </span>
                              <span className="tw-text-center tw-font-bold">
                                £
                                {financeOption.totalAmountToPayByCustomer.toLocaleString(
                                  "en-GB",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  },
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="tw-text-left tw-text-dis-min">
                            Paying by finance will cost you £
                            {financeCharge.toFixed(2)}{" "}
                            more.
                          </div>
                    </>
                  )}
                </td>
                <td className={`${paymentCellClass} [&_div]:tw-border-x-0 [&_div]:tw-border-t-0 [&_div]:tw-border-b [&_div]:tw-border-solid [&_div]:tw-border-dis-divider [&_div]:tw-pb-1`}>
                  {tableExcesses.map((excesses, excessesIndex) => (
                      <div
                        className={detailRowClass}
                        key={`excess-${excessesIndex}`}
                      >
                        <span>
                          {getQuoteExcessLabel(excesses, quote.schemeTableId)}
                        </span>
                        <span>£{excesses.excessAmount}</span>
                      </div>
                    ))}
                </td>
                {configRows.map(({ config, lines, hasValue }, configIndex) => {
                  return (
                    <td
                      key={`config-${config.code}`}
                      className={configIndex === 0 ? paymentCellClass : ""}
                    >
                      {hasValue
                        ? lines.map((line, lineIndex) => (
                            <div key={`line-${lineIndex}`}>
                              {configIndex === 0
                                ? splitForSpace(line.panelItemLine)
                                : line.panelItemLine}
                            </div>
                          ))
                        : "£0"}
                    </td>
                  );
                })}
                <td className="tw-p-[10px]">
                  <div className="tw-flex tw-min-w-[120px] tw-flex-col tw-gap-2">
                    <Button
                      type="button"
                      variant="softQuote"
                      size="small"
                      fullWidth
                      onClick={() => onOpen(quote)}
                    >
                      Quote Details
                    </Button>
                    <Button
                      type="button"
                      variant="main"
                      size="small"
                      fullWidth
                      onClick={(event) => handleBuyClick(event, index, quote)}
                    >
                      Select Quote
                    </Button>
                  </div>
                </td>
              </tr>
              {excessReduction && (
                <tr>
                  <td colSpan={excessReductionColSpan} className="!tw-m-0 !tw-p-0">
                    <TqPanelExcessReduction
                      text={excessReduction}
                      className="tw-box-border tw-flex tw-min-h-10 tw-w-full tw-items-center tw-gap-2 tw-overflow-x-inherit tw-rounded-b-[4px] tw-bg-dis-deep-blue tw-px-3 tw-py-2 tw-leading-[1.4] tw-text-white tw-text-dis-min"
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default TqPanelTable;
